# # Purposely override the existing polyline
# class L.Draw.Polyline extends L.Draw.Polyline

#     addHooks: () ->
#         super()

#         @_mouseMarker.off('click', @_onClick, this)


#         @_map.on('click', @_onClick, this)

#         @_mouseMarker
#             .on('click', @_markerClick, this)
#             .addTo(@_map)


#     _markerClick: (e) ->
#         L.DomEvent.preventDefault(e.originalEvent)

#         @_map.fire('click', e)



#     removeHooks: () ->
#         @_mouseMarker.off('click', @_markerClick, this)
#         super()
#         @_map.off('click', @_onClick, this)


#     # Literally all just because i needed latlng = e.latlng instead of e.target.getLatLng().
#     # for some reason this DIDN'T work using override / super, so i had to copy the whole function
#     _onClick: (e) =>
#         latlng = e.latlng
#         markerCount = @_markers.length

#         if (markerCount > 0 and (not @options.allowIntersection) and @_poly.newLatLngIntersects(latlng))
#             @_showErrorTooltip()
#             return
#         else if (@_errorShown)
#             @_hideErrorTooltip()

#         @_markers.push @_createMarker(latlng)

#         @_poly.addLatLng latlng

#         if (@_poly.getLatLngs().length is 2)
#             @_map.addLayer @_poly


#         @_updateFinishHandler()

#         # @_vertexAdded(latlng)

#         @_clearGuides()

#         @_updateTooltip()
